import { render } from "./OurStorySection.vue?vue&type=template&id=42c83104&scoped=true"
import script from "./OurStorySection.vue?vue&type=script&lang=js"
export * from "./OurStorySection.vue?vue&type=script&lang=js"

import "./OurStorySection.vue?vue&type=style&index=0&id=42c83104&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c83104"]])

export default __exports__